import { useTranslation } from 'react-i18next';

const PILLARS = [
  {
    key: 'p1',
    image:
      'https://readdy.ai/api/search-image?query=An%20open%20laptop%20showing%20a%20detailed%20spreadsheet%20with%20product%20photos%2C%20categories%20and%20columns%2C%20soft%20warm%20desk%20light%20with%20a%20plant%20in%20the%20background%2C%20editorial%20workspace%20photography%2C%20high%20detail%2C%20calm%20and%20organized%20mood&width=800&height=600&seq=pillar-1&orientation=landscape',
  },
  {
    key: 'p2',
    image:
      'https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20held%20over%20a%20folded%20hoodie%20revealing%20fine%20fabric%20texture%2C%20soft%20natural%20window%20light%20on%20a%20warm%20neutral%20surface%2C%20concept%20of%20product%20review%20and%20inspection%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=pillar-2&orientation=landscape',
  },
  {
    key: 'p3',
    image:
      'https://readdy.ai/api/search-image?query=A%20stack%20of%20brown%20cardboard%20shipping%20boxes%20with%20a%20digital%20scale%20and%20measuring%20tape%20on%20a%20clean%20light%20surface%2C%20soft%20natural%20daylight%2C%20minimal%20shipping%20and%20logistics%20concept%20photography%2C%20high%20detail&width=800&height=600&seq=pillar-3&orientation=landscape',
  },
  {
    key: 'p4',
    image:
      'https://readdy.ai/api/search-image?query=Scattered%20paper%20discount%20coupons%20with%20scissors%20and%20a%20bright%20red%20ribbon%20on%20a%20soft%20cream%20table%2C%20warm%20natural%20light%2C%20minimal%20savings%20and%20promotion%20concept%20photography%2C%20high%20detail&width=800&height=600&seq=pillar-4&orientation=landscape',
  },
  {
    key: 'p5',
    image:
      'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20promo%20code%20field%20next%20to%20a%20small%20shopping%20bag%20on%20a%20soft%20sage%20green%20surface%2C%20gentle%20natural%20light%2C%20minimal%20online%20shopping%20concept%20photography%2C%20high%20detail&width=800&height=600&seq=pillar-5&orientation=landscape',
  },
  {
    key: 'p6',
    image:
      'https://readdy.ai/api/search-image?query=A%20wide%20angle%20view%20of%20an%20organized%20warehouse%20with%20tall%20shelves%20of%20boxes%20and%20a%20worker%20with%20a%20clipboard%20in%20soft%20warm%20light%2C%20shallow%20depth%20of%20field%2C%20professional%20logistics%20and%20storage%20photography%2C%20high%20detail&width=800&height=600&seq=pillar-6&orientation=landscape',
  },
  {
    key: 'p7',
    image:
      'https://readdy.ai/api/search-image?query=A%20large%20green%20checkmark%20symbol%20beside%20a%20shield%20emblem%20on%20a%20soft%20warm%20grey%20background%20with%20gentle%20shadows%2C%20minimal%20trust%20and%20legitimacy%20concept%20photography%2C%20high%20detail%2C%20clean%20and%20reassuring&width=800&height=600&seq=pillar-7&orientation=landscape',
  },
  {
    key: 'p8',
    image:
      'https://readdy.ai/api/search-image?query=A%20sturdy%20brass%20padlock%20secured%20on%20a%20chain%20over%20a%20soft%20blush%20pink%20surface%2C%20warm%20natural%20light%20with%20soft%20shadow%2C%20minimal%20security%20and%20safety%20concept%20photography%2C%20high%20detail&width=800&height=600&seq=pillar-8&orientation=landscape',
  },
  {
    key: 'p9',
    image:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20holding%20a%20garment%20under%20a%20bright%20inspection%20light%20with%20a%20magnifying%20loupe%2C%20soft%20neutral%20background%2C%20concept%20of%20quality%20control%20checking%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=pillar-9&orientation=landscape',
  },
  {
    key: 'p10',
    image:
      'https://readdy.ai/api/search-image?query=A%20tidy%20shopping%20cart%20filled%20with%20neatly%20folded%20clothes%20and%20a%20sneaker%20box%20on%20a%20clean%20warm%20studio%20floor%2C%20soft%20natural%20light%2C%20minimal%20buying%20and%20shopping%20guide%20concept%20photography%2C%20high%20detail&width=800&height=600&seq=pillar-10&orientation=landscape',
  },
];

export default function PillarArticlesSection() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24 lg:px-10">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
          {t('pillars.title')}
        </h2>
        <p className="mt-4 text-base text-foreground-600">{t('pillars.subtitle')}</p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3 xl:grid-cols-5">
        {PILLARS.map((p) => (
          <a
            key={p.key}
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-0.5 hover:border-primary-300 cursor-pointer"
          >
            <div className="relative h-32 w-full overflow-hidden">
              <img
                src={p.image}
                alt={t(`pillars.${p.key}.title`)}
                title={`${t(`pillars.${p.key}.title`)} guide`}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                {t(`pillars.${p.key}.title`)}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                {t(`pillars.${p.key}.desc`)}
              </p>
              <span className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600">
                {t('pillars.readMore')}
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm leading-none"></i>
                </span>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}